import { SET_AUTH_DATA } from '../legacy-actions/actionTypes';

export const setAuthData = (state, action) => {
  if (action.type === SET_AUTH_DATA) {
    return { ...state, authData: action.payload };
  }

  return state;
};
